/*
 * ItemAnalysis Messages
 *
 * This contains all the text for the ItemAnalysis component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.Order';

export default defineMessages({
  viewInvoice: {
    id: `${scope}.viewInvoice`,
    defaultMessage: 'Tra cứu hóa đơn',
  },
  invoice: {
    id: `${scope}.invoice`,
    defaultMessage: 'Hóa đơn',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Giá trị hoá đơn (sau VAT)',
  },
  issuedDate: {
    id: `${scope}.issuedDate`,
    defaultMessage: 'Ngày phát hành',
  },
});
